// Functional component for the page which is shown on site landing with user instructions
// Page is replaced when user selects a restaurant from the navbar

import { useContext } from "react";
import { ThemeContext } from "../App";
import LengthBadge from "./LengthBadge";

export const GuidePage = () => {
    const { theme } = useContext(ThemeContext);
    
    return (
        <div className="restaurantcard--background">
            <div className="restaurantcard" id={theme}>
                <div className="restaurantcard--userguide" id={theme}>
                <h1>QTMS</h1>
                <ul>
                    <li>
                    You may view restaurant queue lengths in the left navigation bar.
                    </li>
                    <li>
                    You may sort the list alphabetically or by length by selecting the
                    appropriate icon.
                    </li>
                    <li>
                    You may select a restaurant from the list to view further details and
                    analysis of queue length and waiting time.
                    </li>
                    <li>
                    Below you will find a legend of queue lengths and matching estimated
                    wait times
                    </li>
                </ul>

                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        marginLeft: "50px",
                        marginTop: "30px",
                    }}
                >
                    <LengthBadge queueLabel={"SHORT"} largeBadge={true}></LengthBadge>
                    <p>No wait - 3 minutes 😁</p>
                </div>
                    <div
                        style={{
                        display: "flex",
                        alignItems: "center",
                        marginLeft: "50px",
                        marginTop: "30px",
                    }}
                >
                    <LengthBadge queueLabel={"MEDIUM"} largeBadge={true}></LengthBadge>
                    <p>3 - 6 minutes 😠</p>
                </div>
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        marginLeft: "50px",
                        marginTop: "30px",
                    }}
                >
                    <LengthBadge queueLabel={"LONG"} largeBadge={true}></LengthBadge>
                    <p>More than 6 minutes 😡</p>
                </div>
            </div>
        </div>
    </div>
    );
}

export default GuidePage;
